import OurValue from './OurValue'

export default OurValue
